import { useState } from 'react';
import Lottie from 'react-lottie';
import styles from './index.module.sass';
import classnames from 'classnames/bind';
import autopassTextStatic from './autopass-stop.json';
import autopassTextAnimate from './autopass-splash.json';
import loadingBar from './loading-bar.json';
import { useTimeout } from '@autopass-web/domain';
const cx = classnames.bind(styles);

export const SPLASH_DURATION = 900;

interface SplashProps {
  init: boolean;
}

const Splash = ({ init }: SplashProps) => {
  const [hide, setHide] = useState(false);
  const [isBackgroundAnimationStart, setIsBackgroundAnimationState] =
    useState(false);

  const splashClass = cx({
    splash: true,
    init: isBackgroundAnimationStart,
    hide,
  });

  useTimeout(
    () => {
      setIsBackgroundAnimationState(true);
      setTimeout(() => {
        setHide(true);
      }, SPLASH_DURATION);
    },
    init ? 700 : null,
  );

  if (hide) return null;

  return (
    <div className={splashClass}>
      <div className={styles.lottie}>
        <div className={styles.text}>
          <Lottie
            width={220}
            options={{
              loop: false,
              animationData: autopassTextStatic,
            }}
          />
        </div>
        <div className={styles.text}>
          <Lottie
            width={220}
            isStopped={!init}
            options={{
              loop: false,
              animationData: autopassTextAnimate,
            }}
          />
        </div>

        <div className={styles.bar}>
          <Lottie
            width={270}
            options={{
              animationData: loadingBar,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Splash;
